import { serverAddr } from "../networkConfig";
import { messaging } from "../firebase";
import { onMessage, getToken } from "@firebase/messaging";
import firebase from '@firebase/app';
import { fcmCredentials } from "./Credentials";

export var fcmNotification = {
    mounted(){
        if (this.isFcmSupported()){
            console.log("browser supports FCM");
            this.listenForMessages();
        }else{
            console.log("this browser doesn't support FCM");
        }
    },

    methods: {
        isFcmSupported() {
            // Check Service Worker and Push API
            if (!('serviceWorker' in navigator)) {
                console.log("Service Worker is not supported in this browser.");
                return false;
            }
            if (!('PushManager' in window)) {
                console.log("Push Notifications are not supported in this browser.");
                return false;
            }

            // Check for iOS-specific requirements
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

            if (isiOS && isSafari) {
                // On iOS, ensure the app is running as a PWA
                if (!window.navigator.standalone) {
                    console.log("Notifications on iOS Safari require the app to be installed as a PWA.");
                    return false;
                }
            }

            console.log("This browser supports Firebase Cloud Messaging.");
            return true;
        },
          
        async initFCM(){
            if (this.isFcmSupported()){
                console.log("browser supports FCM");
                await this.requestPermission();
            }else{
                console.log("this browser doesn't support FCM");
            }
        },

        async requestPermission() {
            if ("Notification" in window) {
                try {
                    // await this.deregisteredServiceWorker();
                    await this.registerServiceWorker();

                    const permission = await window.Notification.requestPermission();
                    if (permission === "granted") {
                        console.log("Notification permission granted");

                        const sentToServer = JSON.parse(localStorage.getItem("sentToServer")) === 1;

                        if (sentToServer) {
                            console.log("Token already sent to server!");
                        } else {
                            console.log("Token not sent to server...! getting token");
                            await this.requestToken();
                        }
                    } else {
                        console.log("Notification permission denied");
                    }
                } catch (e) {
                    console.log("Error in getting permission", e);
                }
            } else {
                console.log("Doesn't support notifications");
            }
        },

        async deregisteredServiceWorker(){
            if("serviceWorker" in navigator){
                const registrations = await navigator.serviceWorker.getRegistrations();
    
                for (let registration of registrations) {
                    // Check if it's the FCM service worker by its script URL or other identifier
                    if (registration.active && registration.active.scriptURL.includes('firebase-messaging-sw.js')) {
                        // Unregister the FCM service worker
                        registration.unregister().then(function (boolean) {
                            if (boolean) {
                                console.log('FCM Service worker unregistered successfully');
                            } else {
                                console.log('Failed to unregister FCM Service worker');
                            }
                        });
                    }
                }
            }else{
                console.log("Unable to deregister fcm service worker");
            }
        },

        async registerServiceWorker(){
            // passed the query parameter to fetch updated fcm service worker - declare the same version in the firebase-messaging-sw.js
            if("serviceWorker" in navigator){
                const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js?v=1.0.4");

                if(registration){
                    console.log("registered fcm service worker", registration);
                }
            }
        },

        async requestToken() {
            try {
                const token = await getToken(messaging, { vapidKey: fcmCredentials.vapidKey });

                if (token) {
                    this.SendTokenToServer(true, token);
                    console.log("Token received");
                } else {
                    console.log("No token available");
                    this.SendTokenToServer(false, undefined);
                }
            } catch (e) {
                console.log("Error retrieving token", e);
            }
        },

        SendTokenToServer(shouldSetToLocalStorage, currentToken) {
            localStorage.setItem("sentToServer", shouldSetToLocalStorage ? "1" : "0");

            if(currentToken){
                localStorage.setItem("fcm_token", currentToken);
                this.pushFcmTokenToServer(currentToken);
            }
        },

        listenForMessages() {
            onMessage(messaging, (payload) => {
                console.log("Message received in foreground", payload);
                const notificationTitle = payload.data.title;
                const notificationOptions = {
                    body: payload.data.body,
                    icon: payload.data.icon,
                    imageUrl: payload.data.image
                };

                if (Notification.permission === "granted") {
                    const notifiy = new Notification(notificationTitle, notificationOptions);

                    notifiy.onclick = () => {
                        window.open(payload.data.action);
                    }
                } else {
                    console.log("Notification permission not granted");
                }
            });
        },

        pushFcmTokenToServer(token) {
            let user_id = JSON.parse(localStorage.getItem("user_id"));
            if (user_id && token) {
                serverAddr
                .post("/config/fcm-view/", {
                    user: user_id,
                    type: "web",
                    registration_id: token,
                })
                .then((response) => {
                    if (response.data.status) {
                        console.log("token sent to server");
                        localStorage.setItem("isWelcomeNotificationTokenSent", true);
                    } else {
                        localStorage.setItem("isWelcomeNotificationTokenSent", false);
                    }
                })
                .catch(
                    function (error) {
                        console.log(error);
                        localStorage.setItem("isWelcomeNotificationTokenSent", false);
                    }.bind(this)
                );
            }
        }
    }
}